import NestedCallsEditPage from '../pages/entities/[entityId]/calls/edit.vue'
import NestedCallsNewPage from '../pages/entities/[entityId]/calls/new.vue'
import SpvOnboardingPage from '../pages/spvs/onboarding.vue'
import OnboardingDocument from '../pages/spvs/onboarding-document.vue'
import FundOnboardingPage from '../pages/funds/onboarding.vue'

import NestedCapitalAccountPage from '../pages/entities/[entityId]/capitalAccount/index.vue'
import NestedIndividualOverviewPage from '../pages/individuals/[individualId].vue'
import NestedIndividualInvoicesPage from '../pages/individuals/[individualId]/invoices/index.vue'
import NestedIndividualPortfolioPage from '../pages/individuals/[individualId]/portfolio/index.vue'
import NestedOverviewPage from '../pages/entities/[entityId].vue'
import NestedInvestorsPage from '../pages/entities/[entityId]/investors/index.vue'
import NestedPortfolioPage from '../pages/entities/[entityId]/portfolio/index.vue'
import NestedTransactionsPage from '../pages/entities/[entityId]/transactions/index.vue'
import NestedTransactionsNewPage from '../pages/entities/[entityId]/transactions/new.vue'
import NestedTransactionsEditPage from '../pages/entities/[entityId]/transactions/edit.vue'
import NestedIndividualFundsPage from '../pages/individuals/[individualId]/funds/index.vue'
import NestedIndividualSpvsPage from '../pages/individuals/[individualId]/spvs/index.vue'
import NestedIndividualAssociatedEntitiesPage from '../pages/individuals/[individualId]/associated-entities/index.vue'
import NestedIndividualTaxesPage from '../pages/individuals/[individualId]/taxes/index.vue'
import NestedIndividualAccountPage from '../pages/individuals/[individualId]/account/index.vue'
import NestedIndividualAccreditationPage from '../pages/individuals/[individualId]/accreditation/index.vue'
import NestedIndividualPermissionsPage from '../pages/individuals/[individualId]/permissions/index.vue'
import NestedIndividualBeneficiariesPage from '../pages/individuals/[individualId]/beneficiaries/index.vue'
import NestedIndividualContactsPage from '../pages/individuals/[individualId]/contacts/index.vue'
import NestedEntityNotesPage from '../pages/entities/[entityId]/notes/index.vue'
import NestedIndividualNotesPage from '../pages/individuals/[individualId]/notes/index.vue'
import NestedIndividualLoginInformationPage from '../pages/individuals/[individualId]/loginInformation.vue'
import NestedIndividualInvestmentPreferencesPage from '../pages/individuals/[individualId]/investmentPreferences/index.vue'
import DisbursementEditPage from '../pages/disbursement-edit-page.vue'
import DisbursementNewPage from '../pages/disbursement-new-page.vue'
import DocumentNewPage from '../pages/document-new-page.vue'
import DocumentsPage from '../pages/documents-page.vue'
import EntitiesPage from '../pages/entities-page.vue'
import EntityDocumentsPage from '../pages/entity-documents-page.vue'
import EntityDocumentNewPage from '../pages/entity-document-new-page.vue'
import GuestsPage from '../pages/guests-page.vue'
import IndividualDisbursementPreferencesPage from '../pages/individual-disbursement-preferences-page.vue'
import IndividualDocumentsPage from '../pages/individual-documents-page.vue'
import IndividualOnboardingPage from '../pages/individual-onboarding-page.vue'
import IndividualsImportPage from '../pages/individuals-import-page.vue'
import IndividualsPage from '../pages/individuals-page.vue'
import InvoicesPage from '../pages/invoices-page.vue'
import OtherEntitiesPage from '../pages/other-entities-page.vue'
import OtherEntityDistributionsPage from '../pages/other-entity-distribution-page.vue'
import OtherEntityDocumentsPage from '../pages/other-entity-documents-page.vue'
import OtherEntityNotesPage from '../pages/other-entity-notes-page.vue'
import OtherEntityEditPage from '../pages/other-entity-edit-page.vue'
import OtherEntityInvestorsPage from '../pages/other-entity-investors-page.vue'
import OtherEntityInvoicesPage from '../pages/other-entity-invoices-page.vue'
import OtherEntityNewPage from '../pages/other-entity-new-page.vue'
import OtherEntityOverviewPage from '../pages/other-entity-overview-page.vue'
import OtherEntityPortfolioPage from '../pages/other-entity-portfolio-page.vue'
import OtherEntityFundsPage from '../pages/other-entity-funds-page.vue'
import OtherEntitySpvsPage from '../pages/other-entity-spvs-page.vue'
import OtherEntityAssociatedEntitiesPage from '../pages/other-entity-associated-entities-page.vue'
import AdminsPage from '../pages/admins-page.vue'
import SubgroupsPage from '../pages/subgroups-page.vue'
import SubgroupOverviewPage from '../pages/subgroup-overview-page.vue'
import OwnershipTransfersPage from '../pages/ownership-transfers-page.vue'
import PortfolioPage from '../pages/portfolio-page.vue'

import SpvOverviewV2 from '../pages/spv-overview-v2.vue'

export default [
  {
    component: SpvOnboardingPage,
    name: 'investing.spv-new',
    path: '/:slug/investing/spvs/new',
  },
  {
    component: SpvOnboardingPage,
    name: 'investing.spv-edit',
    path: '/:slug/investing/spv/:entity_id/edit',
  },
  {
    component: OnboardingDocument,
    name: 'investing.spv.onboarding-document',
    path: '/:slug/investing/spv/:entity_id/onboarding-document',
  },
  {
    component: FundOnboardingPage,
    name: 'investing.fund-new',
    path: '/:slug/investing/funds/new',
  },
  {
    component: FundOnboardingPage,
    name: 'investing.fund-edit',
    path: '/:slug/investing/fund/:entity_id/edit',
  },
  {
    component: NestedIndividualOverviewPage,
    name: 'individuals.overview',
    path: '/:slug/investing/individuals/:individual_id',
  },
  {
    component: NestedIndividualInvoicesPage,
    name: 'individuals.invoices',
    path: '/:slug/investing/individuals/:individual_id/invoices',
  },
  {
    component: NestedIndividualPortfolioPage,
    name: 'individuals.portfolio',
    path: '/:slug/investing/individuals/:individual_id/portfolio',
  },
  {
    component: NestedTransactionsPage,
    name: 'investing.transactions',
    path: '/:slug/investing/:entity_type/:entity_id/transactions',
  },
  {
    component: NestedTransactionsNewPage,
    name: 'investing.transactions.new',
    path: '/:slug/investing/:entity_type/:entity_id/transactions/new',
  },
  {
    component: NestedTransactionsEditPage,
    name: 'investing.transactions.edit',
    path: '/:slug/investing/:entity_type/:entity_id/transactions/:batch_transaction_id/edit',
  },
  {
    component: NestedCallsEditPage,
    name: 'investing.capital-call.edit',
    path: '/:slug/investing/:entity_type/:entity_id/calls/:capital_call_id/edit',
  },
  {
    component: NestedCallsNewPage,
    name: 'investing.capital-call.new',
    path: '/:slug/investing/:entity_type/:entity_id/calls/new',
  },
  {
    component: DisbursementEditPage,
    name: 'investing.disbursement.edit',
    path: '/:slug/investing/:entity_type/:entity_id/distributions/:disbursement_id/edit',
  },
  {
    component: DisbursementNewPage,
    name: 'investing.disbursement.new',
    path: '/:slug/investing/:entity_type/:entity_id/distributions/new',
  },
  {
    component: DocumentNewPage,
    name: 'investing.document.new',
    path: '/:slug/investing/document/new',
  },
  {
    component: DocumentsPage,
    name: 'investing.documents',
    path: '/:slug/investing/documents',
  },
  {
    component: EntitiesPage,
    name: 'investing.entities',
    path: '/:slug/investing/:entity_type',
  },
  {
    component: NestedCapitalAccountPage,
    name: 'investing.entity.capital-account',
    path: '/:slug/investing/:entity_type/:entity_id/capital_account',
  },
  {
    component: EntityDocumentsPage,
    name: 'investing.entity.documents',
    path: '/:slug/investing/:entity_type/:entity_id/documents',
  },
  {
    component: NestedEntityNotesPage,
    name: 'investing.entity.notes',
    path: '/:slug/investing/:entity_type/:entity_id/notes',
  },
  {
    component: EntityDocumentNewPage,
    name: 'investing.entity.document.new',
    path: '/:slug/investing/:entity_type/:entity_id/document/new',
  },
  {
    component: NestedOverviewPage,
    name: 'investing.entity-overview',
    path: '/:slug/investing/:entity_type/:entity_id/overview',
  },
  {
    component: GuestsPage,
    name: 'investing.guests',
    path: '/:slug/investing/guests',
  },
  {
    component: IndividualsPage,
    name: 'investing.individuals',
    path: '/:slug/investing/individuals',
  },
  {
    component: IndividualDocumentsPage,
    name: 'investing.individual.documents',
    path: '/:slug/investing/individual/:individual_id/documents',
  },
  {
    component: NestedIndividualInvoicesPage,
    name: 'investing.individual-invoices',
    path: '/:slug/investing/individual/:individual_id/invoices',
  },
  {
    component: IndividualOnboardingPage,
    name: 'investing.individual.onboarding',
    path: '/:slug/investing/individual/:individual_id/onboarding',
  },
  {
    component: NestedIndividualOverviewPage,
    name: 'investing.individual-overview',
    path: '/:slug/investing/individual/:individual_id/overview',
  },
  {
    component: NestedIndividualAccreditationPage,
    name: 'investing.individual.accreditation',
    path: '/:slug/investing/individual/:individual_id/accreditation',
  },
  {
    component: NestedIndividualPermissionsPage,
    name: 'investing.individual.permissions',
    path: '/:slug/investing/individual/:individual_id/permissions',
  },
  {
    component: NestedIndividualBeneficiariesPage,
    name: 'investing.individual.beneficiaries',
    path: '/:slug/investing/individual/:individual_id/beneficiaries',
  },
  {
    component: NestedIndividualContactsPage,
    name: 'investing.individual.contacts',
    path: '/:slug/investing/individual/:individual_id/contacts',
  },
  {
    component: NestedIndividualLoginInformationPage,
    name: 'investing.individual.login-information',
    path: '/:slug/investing/individual/:individual_id/login-information',
  },
  {
    component: NestedIndividualInvestmentPreferencesPage,
    name: 'investing.individual.investment-preferences',
    path: '/:slug/investing/individual/:individual_id/investment-preferences',
  },
  {
    component: NestedIndividualFundsPage,
    name: 'investing.individual.funds',
    path: '/:slug/investing/individual/:individual_id/funds',
  },
  {
    component: NestedIndividualSpvsPage,
    name: 'investing.individual.spvs',
    path: '/:slug/investing/individual/:individual_id/spvs',
  },
  {
    component: NestedIndividualAssociatedEntitiesPage,
    name: 'investing.individual.associated-entities',
    path: '/:slug/investing/individual/:individual_id/associated-entities',
  },
  {
    component: NestedIndividualTaxesPage,
    name: 'investing.individual.taxes',
    path: '/:slug/investing/individual/:individual_id/taxes',
  },
  {
    component: NestedIndividualAccountPage,
    name: 'investing.individual.account',
    path: '/:slug/investing/individual/:individual_id/account',
  },
  {
    component: NestedIndividualNotesPage,
    name: 'investing.individual.notes',
    path: '/:slug/investing/individual/:individual_id/notes',
  },
  {
    component: IndividualDisbursementPreferencesPage,
    name: 'investing.individual.disbursement-preferences',
    path: '/:slug/investing/individual/:individual_id/disbursement-preferences',
  },
  {
    component: IndividualsImportPage,
    name: 'investing.individuals.import',
    path: '/:slug/investing/individuals/import',
  },
  {
    component: NestedInvestorsPage,
    name: 'investing.investors',
    path: '/:slug/investing/:entity_type/:entity_id/investors',
  },
  {
    component: InvoicesPage,
    name: 'investing.invoices',
    path: '/:slug/investing/invoices',
  },
  {
    component: OtherEntitiesPage,
    name: 'investing.other-entities',
    path: '/:slug/investing/associated-entities',
  },
  {
    component: OtherEntityDistributionsPage,
    name: 'investing.other-entity-distributions',
    path: '/:slug/investing/associated-entity/:other_entity_id/distributions',
  },
  {
    component: OtherEntityDocumentsPage,
    name: 'investing.other-entity.documents',
    path: '/:slug/investing/associated-entity/:other_entity_id/documents',
  },
  {
    component: OtherEntityNotesPage,
    name: 'investing.other-entity.notes',
    path: '/:slug/investing/associated-entity/:other_entity_id/notes',
  },
  {
    component: OtherEntityEditPage,
    name: 'investing.other-entity.edit',
    path: '/:slug/investing/associated-entity/:other_entity_id/edit',
  },
  {
    component: OtherEntityInvoicesPage,
    name: 'investing.other-entity.invoices',
    path: '/:slug/investing/associated-entity/:other_entity_id/invoices',
  },
  {
    component: OtherEntityInvestorsPage,
    name: 'investing.other-entity.investors',
    path: '/:slug/investing/associated-entity/:other_entity_id/investors',
  },
  {
    component: OtherEntityNewPage,
    name: 'investing.other-entity.new',
    path: '/:slug/investing/associated-entity/new',
  },
  {
    component: OtherEntityOverviewPage,
    name: 'investing.other-entity.overview',
    path: '/:slug/investing/associated-entity/:other_entity_id/overview',
  },
  {
    component: OtherEntityPortfolioPage,
    name: 'investing.other-entity.portfolio',
    path: '/:slug/investing/associated-entity/:other_entity_id/portfolio',
  },
  {
    component: OtherEntityFundsPage,
    name: 'investing.other-entity.funds',
    path: '/:slug/investing/associated-entity/:other_entity_id/funds',
  },
  {
    component: OtherEntitySpvsPage,
    name: 'investing.other-entity.spvs',
    path: '/:slug/investing/associated-entity/:other_entity_id/spvs',
  },
  {
    component: OtherEntityAssociatedEntitiesPage,
    name: 'investing.other-entity.associated-entities',
    path: '/:slug/investing/associated-entity/:other_entity_id/associated-entities',
  },
  {
    component: AdminsPage,
    name: 'investing.admins',
    path: '/:slug/investing/admins',
  },
  {
    component: SubgroupsPage,
    name: 'investing.subgroups',
    path: '/:slug/investing/subgroups',
  },
  {
    component: SubgroupOverviewPage,
    name: 'investing.subgroup-overview',
    path: '/:slug/investing/subgroup/:subgroup_id/overview',
  },
  {
    component: OwnershipTransfersPage,
    name: 'investing.transfers',
    path: '/:slug/investing/:entity_type/:entity_id/transfers',
  },
  {
    component: PortfolioPage,
    name: 'investing.portfolio',
    path: '/:slug/portfolio',
  },
  {
    component: NestedIndividualPortfolioPage,
    name: 'investing.individual.portfolio',
    path: '/:slug/investing/individual/:individual_id/portfolio',
  },
  {
    component: NestedPortfolioPage,
    name: 'investing.entity.portfolio',
    path: '/:slug/investing/:entity_type/:entity_id/portfolio',
  },
  {
    component: SpvOverviewV2,
    name: 'spv-overview-v2',
    path: '/spv-overview-v2',
  },
  {
    path: '/:slug/investing/:entity_type/:entity_id',
    redirect: (to) => {
      return { name: 'investing.entity-overview', params: to.params }
    },
  },
  {
    path: '/:slug/investing/individual/:individual_id',
    redirect: (to) => {
      return { name: 'investing.individual-overview', params: to.params }
    },
  },
  {
    path: '/:slug/investing/associated-entity/:other_entity_id',
    redirect: (to) => {
      return { name: 'investing.other-entity.overview', params: to.params }
    },
  },
]
